import { useNavigate } from "react-router-dom"
import { Box, Container, Typography } from "@mui/material"

import CarCard from "../../../components/CarCard"
import ShowMoreButton from "../../../components/ShowMoreButton"
import { homeCopy } from "../../../content/homeCopy"
import { useCarPreview } from "../../../hooks/useCars"

const AvailableCars = () => {
    const navigate = useNavigate()
    const { cars, totalCars, loading } = useCarPreview(3)

    return (
        <Box component="section" sx={{ py: { xs: 6, md: 8 }, background: "#fff" }} id="fleet-preview">
            <Container maxWidth="lg">
                <Box textAlign="center" mb={4}>
                    <Typography variant="h4" fontWeight={800} color="#000435" gutterBottom>
                        Driver-ready favourites
                    </Typography>
                    <Typography variant="body1" color="text.secondary" maxWidth={560} mx="auto">
                        {homeCopy.availableCars.subheading}
                    </Typography>
                </Box>

                {!loading && totalCars > 0 && (
                    <Typography variant="body2" textAlign="right" mb={2} color="text.secondary">
                        Showing {cars.length} of {totalCars} cars
                    </Typography>
                )}

                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(2, minmax(0, 1fr))",
                            md: "repeat(3, minmax(0, 1fr))",
                        },
                        gap: 2.5,
                        width: "100%",
                        minWidth: 0,
                        opacity: loading ? 0.55 : 1,
                        transition: "opacity 0.2s ease",
                    }}
                >
                    {cars.map((car, index) => (
                        <CarCard
                            key={car._id.toString()}
                            vehicle={car}
                            aos="fade-up"
                            aosDelay={index * 80}
                        />
                    ))}
                </Box>

                <ShowMoreButton
                    label="View all vehicles"
                    onClick={() => navigate("/vehicles")}
                />
            </Container>
        </Box>
    )
}

export default AvailableCars
